var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-psd-btn-wrapper"},[_c('el-upload',{attrs:{"action":"https://jsonplaceholder.typicode.com/posts/","before-upload":_vm.beforeUpload,"accept":".psd","show-file-list":false}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }